module.exports = __webpack_public_path__ + "static/img/1.e96e9dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/eng/1.png
// module id = 2huI
// module chunks = 0